module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-appbar",
    class: ['mu-paper-' + _vm.zDepth]
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._t("left")], 2), _vm._v(" "), _c('div', {
    staticClass: "mu-appbar-title",
    class: _vm.titleClass
  }, [_vm._t("default", function() {
    return [_c('span', [_vm._v(_vm._s(_vm.title))])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._t("right")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c73d678"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/appBar/appBar.vue
// module id = 492
// module chunks = 1